import { Routes } from '@angular/router';
import { AuthGuard } from '@auth/auth-guard.service';
import { FullLayoutComponent } from '@layouts/full/full-layout.component';
import { ContentLayoutComponent } from '@layouts/content/content-layout.component';
import { TopLayoutComponent } from '@layouts/top/top-layout.component';
import { ErrorPageComponent } from './error/error-page.component';

const auth = import('./auth/auth.module');
const home = import('./home/home.module');
const blog = import('./blog/blog.module');
const master = import('./master/master.module');
const dashboard = import('./dashboard/dashboard.module');
const task = import('./task/task.module');
const bridge = import('./bridge/bridge.module');

export const routes: Routes = [
  // {
  //   path: '',
  //   redirectTo: '/auth/login',
  //   pathMatch: 'full',
  // },
  {
    path: '',
    component: TopLayoutComponent,
    data: { title: 'Top Views' },
    children: [
      { path: '', loadChildren: () => home.then(m => m.HomeModule) },
      { path: 'home', loadChildren: () => home.then(m => m.HomeModule) },
      { path: 'blog', loadChildren: () => blog.then(m => m.BlogModule) },

    ],
  },
  {
    path: '',
    component: FullLayoutComponent,
    canActivate: [AuthGuard],
    data: { title: 'Full Views' },
    children: [
      { path: 'master', loadChildren: () => master.then(m => m.MasterModule) },
      { path: 'dashboard', loadChildren: () => dashboard.then(m => m.DashboardModule) },
      { path: 'task', loadChildren: () => task.then(m => m.TaskModule) },
      { path: 'bridge', loadChildren: () => bridge.then(m => m.BridgeModule) }
    ],
  },
  {
    path: '',
    component: ContentLayoutComponent,
    data: { title: 'Content Views' },
    children: [
      { path: 'auth', loadChildren: () => auth.then(m => m.AuthModule) },
      { path: 'error', component: ErrorPageComponent },
    ]
  },
  {
    path: '**',
    redirectTo: '/error',
    pathMatch: 'full'
  }
];
